import * as React from "react";
import PropTypes from "prop-types";

import youtubeLogo from "../img/social/youtube.svg";
import instagramLogo from "../img/social/instagram.svg";
import facebookLogo from "../img/social/facebook.svg";
import twitterLogo from "../img/social/twitter.svg";
import soundcloudLogo from "../img/social/soundcloud.svg";
import googleLogo from "../img/social/google.svg";

const SocialIcons = ({
  youtube,
  instagram,
  facebook,
  twitter,
  soundcloud,
  socialClass,
  google,
}) => {
  let socialIconClass = "social-icon";
  let thisClass = "social";
  if (socialClass) thisClass = `${socialClass} social`;

  return (
    <div className={thisClass}>
      {youtube ? (
        <a title="YouTube" href={youtube}>
          <img src={youtubeLogo} alt="YouTube" className={socialIconClass} />
        </a>
      ) : null}

      {facebook ? (
        <a title="Facebook" href={facebook}>
          <img src={facebookLogo} alt="Facebook" className={socialIconClass} />
        </a>
      ) : null}

      {twitter ? (
        <a title="Twitter" href={twitter}>
          <img src={twitterLogo} alt="Twitter" className={socialIconClass} />
        </a>
      ) : null}

      {instagram ? (
        <a title="Instagram" href={instagram}>
          <img
            src={instagramLogo}
            alt="Instagram"
            className={socialIconClass}
          />
        </a>
      ) : null}

      {google ? (
        <a title="Google" href={google}>
          <img src={googleLogo} alt="Google" className={socialIconClass} />
        </a>
      ) : null}

      {soundcloud ? (
        <a title="Soundcloud" href={soundcloud}>
          <img
            src={soundcloudLogo}
            alt="Soundcloud"
            className={socialIconClass}
          />
        </a>
      ) : null}
    </div>
  );
};

SocialIcons.propTypes = {
  youtube: PropTypes.string,
  instagram: PropTypes.string,
  facebook: PropTypes.string,
  twitter: PropTypes.string,
  soundcloud: PropTypes.string,
  socialClass: PropTypes.string,
};

export default SocialIcons;
